"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageCreatePayloadSchema = exports.MessageListPayloadSchema = exports.MessageListResponseSchema = exports.MessageObjectSchema = void 0;
const zod_1 = require("zod");
const block_1 = require("../block");
const list_1 = require("../list");
const MessageRoleSchema = zod_1.z.enum(['user', 'system']).openapi('MessageRole');
exports.MessageObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('message'),
    thread: zod_1.z.string(),
    role: MessageRoleSchema,
    content: block_1.BlockListSchema,
    created_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('MessageObject');
exports.MessageListResponseSchema = (0, list_1.ListResponseSchema)(exports.MessageObjectSchema, {
    title: 'MessageList',
});
exports.MessageListPayloadSchema = zod_1.z.object({
    thread: zod_1.z.string(),
});
exports.MessageCreatePayloadSchema = zod_1.z
    .object({
    thread: zod_1.z.string(),
    role: MessageRoleSchema,
    content: block_1.BlockListSchema,
})
    .openapi('MessageCreatePayload');
//# sourceMappingURL=messageSchema.js.map